import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "clair-obscur-expedition-33-any-restricted-w-renoir-skips"
    }}>{`Clair Obscur: Expedition 33 Any% Restricted w/ Renoir Skips`}</h1>
    <h2 {...{
      "id": "this-route-is-invalid"
    }}>{`This route is invalid.`}</h2>
    <p>{`We've decided to disallow the Battle Overlap glitch used to skip Renoir 2 & 3 in Restricted. You can find the allowed route `}<a parentName="p" {...{
        "href": "/Expedition-33/Any-Restricted"
      }}>{`here`}</a>{`.`}</p>
    <p>{`This is the updated route that uses Renoir 2&3 skips and no longer goes to Hidden Gestral Arena.`}<br parentName="p"></br>{`
`}{`You can find the previous route `}<a parentName="p" {...{
        "href": "/Expedition-33/Any-Restricted-Solo-Lune"
      }}>{`here`}</a>{`.`}</p>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <p>{`For loading saves, I will use notation like load S0 to load the top save, or S2 to load the 3rd save (2 down).`}<br parentName="p"></br>{`
`}{`These will assume no mistakes, since mistakes will often lead to extra saves. The notes will still describe which save to load.`}</p>
    <p>{`There's also a debug reload you can do by pressing Alt+V. I will refer to this as `}<strong parentName="p">{`Debug Load`}</strong>{`. You generally have to mash it as you enter an area, exit a menu, or load screen is ending.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <p>{`Do Windmill skip. The notes will assume you do it, but will note small changes if you fight Maelle where applicable.`}<br parentName="p"></br>{`
`}{`If you're learning, don't bother with Windmill and just fight Maelle.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "maelle-450hp"
      }}>{`Maelle 450HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Attack > Parry > 3 Shots (2 if 1 head), Attack > Parry`}</p>
    </Battle>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu timing="Cutscene entering Lancelier or Portier" mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Lumiere Assault Left-Bottom`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot twice, Attack > Parry`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot + 1 shot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`. Can do house skip to save ~1s. Don't need the pickups.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` by Portier.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you aren't going to `}<strong parentName="p">{`Debug Load`}</strong>{` the Delaram upgrade, can pick up a Lumina in SWC instead.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Battle>
    <Menu timing="During journal cutscene" mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <p>{`-+Gustave`}</p>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` under the bridge.`}</p>
    <Menu timing="Flag before Eveque" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Might (6)`}</li>
        <li parentName="ul">{`Lune: +6 Might (6)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Eveque battle" mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Dead Energy II`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "eveque-139"
      }}>{`Eveque (1:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Lumiere Assault`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Gustave / Ice Lance / Attack`}</li>
        <li parentName="ul">{`Gustav: Can shoot till 4AP, Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}</p>
    </Battle>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <p>{`Optionally, menu during cutscene and remove Gustave's pictos.`}</p>
    <p>{`Load most recent save after autosave after Demineurs. If you don't get one, make a picto save.`}</p>
    <p>{`Menu during the cutscene where you enter Maelle's room.`}</p>
    <Menu timing="Cutscene entering Flying Waters or Manor" mdxType="Menu">
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: -Lumiere Assault`}</li>
      </ul>
    </Menu>
    <Menu timing="Getting Maelle" mdxType="Menu">
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: -Spark`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`After getting Maelle, reload the manor autosave (Top+1)`}<br parentName="p"></br>{`
`}{`After talking to door, open menu as screen is fading out and load most recent autosave.`}</p>
    <p>{`If no drop, pick up `}<strong parentName="p">{`Recoat`}</strong>{`.`}</p>
    <p>{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +6 Might (12)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
        <li parentName="ul">{`Lune: +3 Might (9), +3 Agility (3)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Marking Shot`}</li>
        <li parentName="ul">{`Maelle: +Swift Stride`}</li>
        <li parentName="ul">{`Lune: +Rockslide`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Staggering Attack`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Do `}<strong parentName="p">{`Goblu Skip`}</strong></p>
    <h3 {...{
      "id": "camp"
    }}>{`Camp`}</h3>
    <Menu timing="Talk to Curator" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Maellum +1 (3)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-resources"
      }}>{`Upgrade Resources`}</h5>
      <p>{`-Lune: +2 Lumina`}</p>
    </Menu>
    <Menu timing="Jump to campfire" mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Staggering Attack (Mash A)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Reload the latest autosave (can debug load exiting menu), go to sleep.`}</p>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Password Skip`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "francois-035"
      }}>{`Francois (0:35)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot 2 times (3 if Lune target), Immolation`}</li>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <p>{`Counter if Maelle target for crit safety.`}</p>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, counter until 800 counter damage.`}</p>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Gustave if 0AP, else skip`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <p>{`Menu during Esquie's cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <p>{`-+Lune`}</p>
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Rockslide Bottom-Left`}</li>
      </ul>
    </Menu>
    <p>{`After talking to Esquie cutscene, load autosave outside Flying Waters (Top + 1).`}<br parentName="p"></br>{`
`}{`Go to Flying Waters entrance, then reload most recent autosave and mash to enter Flying Waters.`}</p>
    <p>{`Watch load screen, once the "stars" disappear mash `}<strong parentName="p">{`Debug Load`}</strong>{` to reload save to setup dupe'd save.`}<br parentName="p"></br>{`
`}{`Then exit Flying Waters.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This save will be loaded during OL skip, should be 3-4s gap between saves.`}</p>
    </blockquote>
    <h3 {...{
      "id": "continent-2"
    }}>{`Continent`}</h3>
    <p>{`Chroma Elixer to autosave at midpoint between SWC and ES1.`}<br parentName="p"></br>{`
`}{`Right before picking up `}<strong parentName="p">{`Energising Start I`}</strong>{`, reload most recent autosave and pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` during the load.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to SWC entrance and camp.`}</p>
    <h3 {...{
      "id": "camp-1"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-3"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Menu during first cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+(S2) Energising Start I`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{`. Picto save for Delaram warp.`}</p>
    <p>{`Unlock Paint Cage, reload autosave and pick up `}<strong parentName="p">{`Delaram`}</strong>{` during the load.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`.`}</p>
    <Menu timing="Jump down from First Strike" mdxType="Menu">
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +(S3) First Strike`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`SOS Power`}</strong>{`.`}</p>
    <Menu timing="Jump at start of Farm" mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`If 2 Francois Polished drops, can pick up `}<strong parentName="p">{`Polished Chroma Catalyst`}</strong>{`.`}</p>
    </blockquote>
    <p>{`Pick up `}<strong parentName="p">{`Duenum`}</strong>{`.`}</p>
    <p>{`Do Cave skip and pick up `}<strong parentName="p">{`Coralim`}</strong>{`.`}</p>
    <Menu timing="Flag before Lampmaster" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +6 Might (18)`}</li>
        <li parentName="ul">{`Maelle: +3 Might (18)`}</li>
        <li parentName="ul">{`Lune: +6 Might (15)`}</li>
      </ul>
    </Menu>
    <Menu timing="Lampmaster cutscene" mdxType="Menu">
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Delaram`}</li>
        <li parentName="ul">{`Maelle: Duenum`}</li>
        <li parentName="ul">{`Lune: Coralim`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`This fight is pretty dynamic, so practice is recommended here.`}</p>
      </blockquote>
      <h4 {...{
        "id": "lampmaster-227"
      }}>{`Lampmaster (2:27)`}</h4>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Powerful / Energy Tint Lune`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
        <li parentName="ul">{`Lune: Rockslide`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If not dead yet, go into backup script`}</p>
      </blockquote>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
        <li parentName="ul">{`Lune: Rockslide`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Overcharge`}</li>
        <li parentName="ul">{`Best damage if not dead yet.`}</li>
      </ul>
      <h4 {...{
        "id": "backup-script"
      }}>{`Backup Script`}</h4>
      <h5 {...{
        "id": "p1-turn-3"
      }}>{`P1 Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <h4 {...{
        "id": "phase-2-1"
      }}>{`Phase 2`}</h4>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
        <li parentName="ul">{`Lune: Rockslide`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Overcharge`}</li>
      </ul>
    </Battle>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <h3 {...{
      "id": "camp-2"
    }}>{`Camp`}</h3>
    <Menu timing="Camp flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +33 Might`}</li>
        <li parentName="ul">{`Maelle: +15 Might (33)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Rain of Fire`}</li>
        <li parentName="ul">{`Verso: +Perfect Recovery, +Berserk Slash (Left-Middle)`}</li>
      </ul>
    </Menu>
    <Menu timing="Near campfire" mdxType="Menu">
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Do Pictos from left menu`}</p>
      </blockquote>
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Augmented First Strike > SOS Power (No Swap)`}</li>
            <li parentName="ul">{`+At Death's Door > Staggering Attack`}</li>
            <li parentName="ul">{`+Dead Energy II > At Death's Door `}<strong parentName="li">{`(Swap)`}</strong></li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <p>{`_Hover Delaram, `}<strong parentName="p">{`Debug Load`}</strong>{` and instantly hold A to Upgrade Weapon.`}</p>
      <ul>
        <li parentName="ul">{`Verso: Delaram +1 (8)`}</li>
      </ul>
    </Menu>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-4"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier"
      }}>{`Chalier`}</h4>
      <ul>
        <li parentName="ul">{`Parry 1st hit.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash (survives with not-Verso target and no crits)`}</li>
      </ul>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity`}</strong>{`.`}</p>
    <Menu timing="For safety save during Launch setup" mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Inverted Affinity > Dead Energy II`}</li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Do launch out of `}<strong parentName="p">{`Forgotten Battlefield`}</strong>{`.`}</p>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-5"
    }}>{`Continent`}</h3>
    <h4 {...{
      "id": "monoco-station-skip"
    }}>{`Monoco Station Skip`}</h4>
    <p>{`Go to fight in front of you and preempt it.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier-cruler-bruler"
      }}>{`Chalier, Cruler, Bruler?`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Flee`}</li>
      </ul>
    </Battle>
    <Menu timing="Before next fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +At Death's Door > Augmented First Strike (Swap)`}</li>
      </ul>
    </Menu>
    <p>{`Go to fight by Monoco Station entrance.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "demineur-troubador-gault-008"
      }}>{`Demineur, Troubador, Gault (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8268XP, $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur once.`}</li>
            <li parentName="ul">{`Shoot Troubadour weakness twice`}</li>
            <li parentName="ul">{`Attack Gault`}</li>
          </ul></li>
      </ul>
    </Battle>
    <p>{`Go to invisible bridge, Picto save & reload (can `}<strong parentName="p">{`debug load`}</strong>{`).`}<br parentName="p"></br>{`
`}{`Do Monoco Station skip.`}</p>
    <h4 {...{
      "id": "old-lumiere-skip"
    }}>{`Old Lumiere Skip`}</h4>
    <p>{`Picto save anywhere along the way to the building where you can mount & dismount Esquie.`}</p>
    <blockquote>
      <p parentName="blockquote">{`We're gonna use a new term here, Esquie Debug Load Mount Storage, or `}<strong parentName="p">{`EDLMS`}</strong>{`. You can load a save, `}<strong parentName="p">{`Debug Load`}</strong>{` as it loads in, and mount/dismount Esquie to transfer mount state to your S0 save.`}</p>
    </blockquote>
    <p>{`Climb up building. Picto save, and load S1. `}<strong parentName="p">{`EDLMS`}</strong>{`.`}</p>
    <p>{`Go to cliff edge for Esquie mount. Picto save, load the save outside Flying Waters from Act 1.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Save should be ~12s apart from the one above it, ~3s apart from the one below it.`}</p>
    </blockquote>
    <p>{`Run into Flying Waters trigger (want to get bit deep into it, so Esquie is mountable). Picto save, while game is saving open save menu and load S2. Back out, open and close menu quickly, and mount Esquie `}<strong parentName="p">{`using Z on keyboard`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`My prefered way to do this is use Tab to open menu, Circle to close, and Z to Mount`}</p>
    </blockquote>
    <p>{`Run up mountain, get onto building past railing. Picto save, `}<strong parentName="p">{`load S4`}</strong>{`. `}<strong parentName="p">{`EDLMS`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Save number might not be accurate, it's the same save used for first `}<strong parentName="p">{`EDLMS`}</strong>{`.`}</p>
    </blockquote>
    <p>{`Run off the building on the left side. Run on invisible ground to the left over the water, and climb onto mountain in front. Picto save, and load `}<strong parentName="p">{`S3 - by Flying Waters`}</strong>{`. `}<strong parentName="p">{`EDLMS`}</strong>{` (use Z on keyboard for the mount).`}</p>
    <p>{`Ride Esquie past the trees and off into the water. There's a part of the ground that protrudes out like a dock.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Visages`}</strong>{`.`}</p>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <Menu timing="During cutscene at start" mdxType="Menu">
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity > Inverted Affinity (to set HP to 2)`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to Joy Mask.`}</p>
    <Menu timing="Cutscene entering Joy Mask" mdxType="Menu">
      <h5 {...{
        "id": "skills-4"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire Left-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu timing="Jump down to Joy Mask" mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Confident Fighter`}</li>
      </ul>
    </Menu>
    <p>{`Go to Joy Mask, Option 1 to take Fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chapelier-moissoneusse-bouchelier-021"
      }}>{`Chapelier, Moissoneusse, Bouchelier (0:21)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`76284XP, $3822, Chapelim LV11, 1 Resplendant`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Shoot Chapelier's `}<strong parentName="li">{`HEAD`}</strong>{` 3 times. Berserk Slash Moissoneusse.`}</li>
      </ul>
      <p>{`Bouchelier will do something, only counter if Gradient.`}</p>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Shoot off shields from Bouchelier, skip.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <p>{`Go to Visages.`}</p>
    <Menu timing="Flag before Visages" mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +Storm Caller, Lightning Dance Left-Bottom`}</li>
      </ul>
    </Menu>
    <Menu timing="Entering Mask Keeper fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-2"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: (1U) Chapelim`}</li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`(R3) +First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "visages-1"
      }}>{`Visages`}</h4>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <p><strong parentName="p">{`Dodge`}</strong>{` 1 hit of 1st move, Counter 2nd move.`}</p>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
      </ul>
      <p>{`Counter if needed, should die to Storm Caller.`}</p>
    </Battle>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "monolith"
    }}>{`Monolith`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Luck +42 (42)`}</li>
        <li parentName="ul">{`Verso: Agility +27 (27)`}</li>
        <li parentName="ul">{`Maelle: Agility +27 (27)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Wildfire Right-Top`}</li>
        <li parentName="ul">{`Maelle: +Last Chance Left-Top`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene before Feetress" mdxType="Menu">
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`Remove S1`}</li>
            <li parentName="ul">{`(Triangle) Immaculate > Energising Start I`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(R2) +At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "feetress"
      }}>{`Feetress`}</h4>
      <ul>
        <li parentName="ul">{`Maelle: Skip x2`}</li>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire Fail QTE`}</li>
      </ul>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{`.`}</p>
    <Menu timing="Jump at end of Tainted Forgotten Battlefield" mdxType="Menu">
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Weakness Gain`}</li>
      </ul>
    </Menu>
    <p>{`Do Renoir 2 Skip. Reload save so you can run.`}</p>
    <Menu timing="Jumping into portal for Monolith Peak" mdxType="Menu">
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <p>{`Equip Barrier Breaker (Go to inventory and mash confirm)`}</p>
    </Menu>
    <Menu timing="Cutscene entering Paintress battle" mdxType="Menu">
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`Staggering Attack > At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`(R2) +At Death's Door`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "paintress-356"
      }}>{`Paintress (3:56)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Painted Power, Resplendant x3`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`Counter everything.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Maelle: Shots if needed, Swift Stride`}</li>
      </ul>
      <h4 {...{
        "id": "phase-2-2"
      }}>{`Phase 2`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3"
      }}>{`Phase 3`}</h4>
      <h5 {...{
        "id": "turn-45"
      }}>{`Turn 4.5`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Skip / Rain of Fire if Verso Heal`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "act-3"
    }}>{`Act 3`}</h3>
    <Menu timing="Cutscene talking to Renoir" mdxType="Menu">
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Remove S1`}</li>
            <li parentName="ul">{`Remove S2`}</li>
            <li parentName="ul">{`(S3 Triangle) +Painted Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-5"
    }}>{`Camp`}</h3>
    <p>{`Load save outside `}<strong parentName="p">{`Flying Waters`}</strong>{`. Load S0 and enter Flying Waters while loading. Can use `}<strong parentName="p">{`Debug Load`}</strong>{` for this.`}</p>
    <h3 {...{
      "id": "flying-waters-1"
    }}>{`Flying Waters`}</h3>
    <p>{`Exit instantly`}</p>
    <Menu timing="While jumping out of Flying Waters" mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`This is optional`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <p>{`-Lune`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-6"
    }}>{`Continent`}</h3>
    <p>{`Fly to Lumiere`}</p>
    <h3 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Charging Stun`}</strong>{` behind tree from Prologue.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Recoat`}</strong>{` on the way to Abberations if none owned.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Gradient Fighter`}</strong>{` behind Abberations used for Renoir 3 skip.`}</p>
    <Menu timing="Flag before Renoir 3" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Recoat, +75 Agility`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Stendhal, Equip Left-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Do Renoir 3 Skip. Reload save to regain running ability.`}</p>
    <Menu timing="Before Verso fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Gradient Fighter`}</li>
            <li parentName="ul">{`+Charging Stun`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "verso"
      }}>{`Verso`}</h4>
      <ul>
        <li parentName="ul">{`Last Chance > Stendhal`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "links"
    }}>{`Links`}</h3>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/MhUR2Jv_vvI?si=T2P1dlXM02oTzGGw"
      }}>{`Cardinal's Windmill`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=a5EVfG5KKVs&list=PLEdCsgJaGX6KNlVMMzIbkyy4Exq7R2voN"
      }}>{`Cardinal Playlist`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ilRC2Te-Q04"
      }}>{`Cardinal Old Lumiere Skip`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://youtu.be/wpj4CUCesO0"
      }}>{`Password Skip`}</a></p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h5 {...{
      "id": "60126"
    }}>{`6/01/26`}</h5>
    <ul>
      <li parentName="ul">{`Move Augmented First Strike to SWC menu`}</li>
      <li parentName="ul">{`Add timing note for the Flying Waters debug load`}</li>
    </ul>
    <h5 {...{
      "id": "53126"
    }}>{`5/31/26`}</h5>
    <ul>
      <li parentName="ul">{`Move Wildfire to Right-Top`}</li>
    </ul>
    <h5 {...{
      "id": "53026-pt2"
    }}>{`5/30/26 Pt.2`}</h5>
    <ul>
      <li parentName="ul">{`Pick up 2 Lumina in Spring Meadows`}</li>
      <li parentName="ul">{`Give Lune 2 Lumina after upgrading Maellum`}</li>
      <li parentName="ul">{`Add missing Lune formation toggle to Esquie's Nest menu`}</li>
      <li parentName="ul">{`Fix Esquie's Nest menu, give Maelle Augmented First Strike`}</li>
      <li parentName="ul">{`Move Verso DE2 Lumina equip to Inverted equip. Delay Crit Burn equip to cutscene menu.`}</li>
      <li parentName="ul">{`Alt+V Delaram upgrade`}</li>
      <li parentName="ul">{`No longer upgrade Chapelim, just give Lune DE2 instead.`}</li>
      <li parentName="ul">{`Also give Verso Augmented First Strike lumina before Paintress`}</li>
    </ul>
    <h5 {...{
      "id": "53026"
    }}>{`5/30/26`}</h5>
    <ul>
      <li parentName="ul">{`First draft with Renoir skips`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      